'use strict';

// EXPORTS //

module.exports = Math.sqrt;
